import { AxiosResponse } from 'axios';

import { ProductType } from '../../../common';
import {
  FromPrice,
  GroupPricesBodyParameters,
  SFCCGroupPrice,
  SFCCPricingSearchResult,
} from '../../models';
import { getPricingApiConfig, pricingHttp } from '../pricing-api';
import { getPricesByIds } from './get-prices-by-ids';

/**
 * Fetches group prices for the given group IDs.
 * @param groupIds - An array of group IDs to fetch prices for.
 * @returns A Promise resolving to an array of FromPrice or SFCCGroupPrice, or null if no prices are found.
 */
export const getGroupPrices = async (
  groupIds: number[]
): Promise<FromPrice[] | SFCCGroupPrice[] | null> => {
  const { isSFCCPricingOn, marketLocale } = getPricingApiConfig();

  try {
    if (isSFCCPricingOn) {
      const response = await getPricesByIds<SFCCPricingSearchResult>(groupIds, ProductType.Group);
      return response?.search_phrase_suggestions?.c_prices || null;
    } else {
      const response = await pricingHttp.post<
        GroupPricesBodyParameters,
        AxiosResponse<FromPrice[]>
      >('/group', {
        groupIds,
        marketLocale,
      });

      return response.data || null;
    }
  } catch (error) {
    console.error(`Error fetching group prices for IDs ${groupIds}:`, error);
    return null;
  }
};
